import * as React from 'react';

export const preventDefault = (event: React.MouseEvent) => event.preventDefault();
